import { useQuery } from '@tanstack/react-query'

import { listResourceKinds } from '../api/resources'

/**
 * Fetches the list of registered resource kinds from `/api/resource-kinds`.
 * Cached for 10 minutes — kind metadata is static for the lifetime of a hub
 * process.
 */
export function useResourceKinds() {
  return useQuery({
    queryKey: ['resource-kinds'],
    queryFn: listResourceKinds,
    staleTime: 10 * 60_000,
  })
}
